import useAPI from '../useAPI'
import { create } from '@/api/domains.api'

export const useCreateDomain = (params = {}) => useAPI({
  request: create,
  params
})
